import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';
import { errore } from './comuni';

// Impostazioni → Modelli: i testi pronti per "Messaggio al cliente" e WhatsApp ({nome}, {immobile}, {data},
// {consulente}), e le email che MK Client manda da sola: anteprima con dati finti, prova al proprio indirizzo,
// evento acceso o spento (backend/notifiche.py).

const A = { cliente: 'ai clienti', staff: 'allo staff', esterni: 'ad agenzie, banche e notai' };

const ModelloMessaggio = ({ m, onSalvato }) => {
  const [dati, setDati] = useState({ nome: m.nome, oggetto: m.oggetto || '', testo: m.testo });
  const salva = async () => {
    try { await axios.put(`${API}/modelli-messaggio/${m.id}`, dati); toast.success('Modello salvato'); onSalvato(); } catch (e) { toast.error(errore(e, 'Non salvato')); }
  };
  const togli = async () => {
    try { await axios.delete(`${API}/modelli-messaggio/${m.id}`); toast.success(m.di_base ? 'Tornato com\'era' : 'Tolto'); onSalvato(); } catch (e) { toast.error(errore(e, 'Non riuscito')); }
  };
  return (
    <div className="imp-modello" data-testid={`modello-${m.id}`}>
      <div className="imp-campi">
        <label>Nome del modello<input value={dati.nome} onChange={(e) => setDati({ ...dati, nome: e.target.value })} /></label>
        <label>Oggetto<input value={dati.oggetto} onChange={(e) => setDati({ ...dati, oggetto: e.target.value })} /></label>
        <label className="largo">Testo del modello<textarea rows={3} value={dati.testo} onChange={(e) => setDati({ ...dati, testo: e.target.value })} /></label>
      </div>
      <div className="imp-azioni">
        {m.di_base && <span className="tag t-o">{m.modificato ? 'di base, cambiato' : 'di base'}</span>}
        <button type="button" className="btn sm p" onClick={salva}>Salva</button>
        {(!m.di_base || m.modificato) && <button type="button" className="btn sm rosso-vuoto" onClick={togli}>{m.di_base ? 'Com\'era' : 'Togli'}</button>}
      </div>
    </div>
  );
};

const Messaggi = () => {
  const [dati, setDati] = useState(null);
  const [nuovo, setNuovo] = useState(null);
  const carica = useCallback(() => axios.get(`${API}/modelli-messaggio`).then((r) => setDati(r.data)).catch(() => setDati({ modelli: [], segnaposto: [] })), []);
  useEffect(() => { carica(); }, [carica]);
  const aggiungi = async () => {
    try { await axios.post(`${API}/modelli-messaggio`, nuovo); setNuovo(null); carica(); toast.success('Modello aggiunto'); } catch (e) { toast.error(errore(e, 'Non aggiunto')); }
  };
  if (!dati) return <p className="vuoto">Carico i modelli…</p>;
  return (
    <section className="card" data-testid="modelli-messaggi">
      <div className="ttl"><div className="i g"><Icona nome="whatsapp" /></div><h2>Messaggi e WhatsApp <small>{dati.modelli.length}</small></h2>
        {!nuovo && <button type="button" className="link" onClick={() => setNuovo({ nome: '', oggetto: '', testo: '' })}>+ Modello</button>}</div>
      <p className="imp-nota">Segnaposto: {dati.segnaposto.join(' ')} — nella scheda cliente si riempiono da soli (nome del cliente, immobile scelto o prossima visita, data, chi scrive).</p>
      {nuovo && (
        <div className="riquadro" style={{ marginTop: '.8rem' }}>
          <div className="imp-campi">
            <label>Nome<input placeholder="es. Chiavi pronte" value={nuovo.nome} onChange={(e) => setNuovo({ ...nuovo, nome: e.target.value })} /></label>
            <label>Oggetto<input value={nuovo.oggetto} onChange={(e) => setNuovo({ ...nuovo, oggetto: e.target.value })} /></label>
            <label className="largo">Testo<textarea rows={3} placeholder="Ciao {nome}, …" value={nuovo.testo} onChange={(e) => setNuovo({ ...nuovo, testo: e.target.value })} /></label>
          </div>
          <div className="imp-azioni"><button type="button" className="btn sm p" onClick={aggiungi}>Aggiungi</button><button type="button" className="btn sm" onClick={() => setNuovo(null)}>Annulla</button></div>
        </div>
      )}
      <div className="imp-modelli">
        {dati.modelli.map((m) => <ModelloMessaggio key={`${m.id}-${m.modificato}-${m.testo}`} m={m} onSalvato={carica} />)}
      </div>
    </section>
  );
};

const Email = () => {
  const [eventi, setEventi] = useState(null);
  const [aperto, setAperto] = useState(null);
  const [html, setHtml] = useState('');
  const [testo, setTesto] = useState(false);
  const carica = useCallback(() => axios.get(`${API}/notifiche/catalogo`).then((r) => setEventi(r.data)).catch(() => setEventi([])), []);
  useEffect(() => { carica(); }, [carica]);
  useEffect(() => {
    if (!aperto) return;
    axios.get(`${API}/notifiche/anteprima/${aperto}`, { params: { formato: testo ? 'testo' : 'html' }, responseType: 'text' })
      .then((r) => setHtml(r.data)).catch(() => setHtml(''));
  }, [aperto, testo]);
  const attiva = async (e, v) => { try { await axios.put(`${API}/notifiche/${e.id}/attivo`, { attivo: v }); carica(); } catch (err) { toast.error(errore(err, 'Non riuscito')); } };
  const prova = async (e) => {
    try { const r = await axios.post(`${API}/notifiche/prova/${e.id}`); toast.success(`Prova mandata a ${r.data.a}`); } catch (err) { toast.error(errore(err, 'Prova non mandata')); }
  };
  if (!eventi) return <p className="vuoto">Carico le email…</p>;
  const scelto = eventi.find((e) => e.id === aperto);
  return (
    <div className="imp-due" data-testid="modelli-email">
      <section className="card">
        <div className="ttl"><div className="i b"><Icona nome="campanella" /></div><h2>Email e avvisi automatici <small>{eventi.length}</small></h2></div>
        {['cliente', 'staff', 'esterni'].map((gruppo) => (
          <div key={gruppo}>
            <p className="imp-gruppo">{A[gruppo]}</p>
            <div className="imp-righe">
              {eventi.filter((e) => e.a === gruppo).map((e) => (
                <div key={e.id} className={aperto === e.id ? 'scelto' : undefined}>
                  <button type="button" className="apri" onClick={() => setAperto(e.id)} aria-pressed={aperto === e.id}>
                    <b>{e.nome}</b><span>{e.oggetto} · {e.canali.join(', ')}</span>
                  </button>
                  <label className="spunta" title={e.obbligatorio ? 'Non si può spegnere' : ''}>
                    <input type="checkbox" checked={e.attivo} disabled={e.obbligatorio} onChange={(ev) => attiva(e, ev.target.checked)} aria-label={`${e.nome} attivo`} />attivo
                  </label>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
      <section className="card imp-anteprima">
        <div className="ttl"><div className="i"><Icona nome="documento" /></div><h2>{scelto ? scelto.nome : 'Anteprima'}</h2>
          {scelto && <button type="button" className="link" onClick={() => setTesto(!testo)}>{testo ? 'HTML' : 'Solo testo'}</button>}</div>
        {!scelto && <p className="vuoto">Scegliete un'email per vederla con dati di prova.</p>}
        {scelto && (testo
          ? <pre className="anteprima-testo" data-testid="anteprima-testo">{html}</pre>
          : <iframe title="Anteprima email" sandbox="" srcDoc={html} className="anteprima-email" data-testid="anteprima-email" />)}
        {scelto && (
          <div className="imp-azioni">
            <button type="button" className="btn sm p" onClick={() => prova(scelto)}>Mandami una prova</button>
            {scelto.lingue.length === 1 && <span className="imp-nota">Solo in italiano per ora: nelle altre lingue del cliente vale questo testo.</span>}
          </div>
        )}
      </section>
    </div>
  );
};

const Modelli = () => (
  <div className="imp-griglia">
    <Messaggi />
    <Email />
  </div>
);

export default Modelli;
